export default __webpack_public_path__ + "static/login-2c9136ee603ca1ba7bdbff7e06b91060.jpg";